/* eslint-disable */

<template>
  <div id="copyright">
    <div id="logo-bar">
      <a
        target="_blank"
        :href="'https://uni.wroc.pl'"
      >
        <img
          src="../assets/images/uwr.png"
          class="d-inline-block align-top"
        />
      </a>
      <a
        v-if="this.$i18n.locale === 'pl'"
        target="_blank"
        href="https://pwr.edu.pl/"
      >
        <img
          src="../assets/images/pwr_PL_white.png"
          class="d-inline-block align-top"
          style="padding: 18px"
        />
      </a>
      <a
        v-if="this.$i18n.locale === 'en'"
        target="_blank"
        href="https://pwr.edu.pl/en"
      >
        <img
          src="../assets/images/pwr_PL_white.png"
          class="d-inline-block align-top"
          style="padding: 18px"
        />
      </a>
      <a
        target="_blank"
        :href="'https://clarin-pl.eu/'"
      >
        <img
          src="../assets/images/clarin-pl_logo_pl_white.png"
          class="d-inline-block align-top"
          style="padding: 10px 5px"
        />
      </a>
      <a
        target="_blank"
        :href="'https://clarin-pl.eu/'"
      >
        <img
          src="../assets/images/logo_cl_white.png"
          class="d-inline-block align-top"
        />
      </a>
      <a
        target="_blank"
        style="margin-right: 2rem"
      >
        <img
          src="../assets/images/fe_bw.png"
          class="d-inline-block align-top"
          style="padding: 1px 1px"
        />
        <img
          id="flaga_pl"
          src="../assets/images/flaga_pl.png"
          class="d-inline-block align-top"
          style="padding: 10px 5px"
        />
        <img
          src="../assets/images/ue_bw.png"
          class="d-inline-block align-top"
          style="padding: 10px 5px"
        />
      </a>
    </div>

    <div class="copy">
      {{ $t("footer.copyright").split("%%")[0].replace("#year#", new Date().getFullYear()) }}
      <br />
      {{ $t("footer.copyright").split("%%")[1] }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
#copyright {
  font-size: 16px;
  font-size: 1.5vh;
  color: white;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 60px;
  margin-top: 0;
  padding-top: 0rem;
  padding-bottom: 0rem;
  background-color: var(--grey_black);
}
#logo-bar {
  margin-top: 0rem;
  height: 60px;
}
#logo-bar img {
  height: 100%;
  padding: 5px;
  filter: grayscale(100%);
}
#flaga_pl {
  filter: none !important;
}
.copy {
  display: flex;
  align-items: center;
  height: 60px;
  font-size: 12px;
}
@media only screen and (min-width: 768px) {
}
@media only screen and (min-width: 375px) {
  #copyright {
    height: fit-content;
  }
  .copy {
    padding-top: 1rem;
    display: flex;
    align-items: flex-start;
    height: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue